import { defineMessages } from 'react-intl';
export default defineMessages({
  actionchoosePeopleNumerFailed: {
    id: 'action.choosePeopleNumerFailed',
    defaultMessage: '选定人数失败，请稍候重试',
  },
  actionselectedNumberOfPeople: {
    id: 'action.selectedNumberOfPeople',
    defaultMessage: '该桌台已经选定人数',
  },
  actiongettingCoupon: {
    id: 'action.gettingCoupon',
    defaultMessage: '正在领券中...',
  },
  actionrequestInterfaceFailed: {
    id: 'action.requestInterfaceFailed',
    defaultMessage: '请求接口失败...',
  },
  actionRetryToGet: {
    id: 'action.RetryToGet',
    defaultMessage: '非常抱歉，领取失败，请重试',
  },
  actionsysInProcessing: {
    id: 'action.sysInProcessing',
    defaultMessage: '系统处理中...',
  },
  actionmodifySuccess: {
    id: 'action.modifySuccess',
    defaultMessage: '修改成功',
  },
  actionJumping: {
    id: 'action.Jumping',
    defaultMessage: '页面跳转中...',
  },
  actionshopIdCannotBeNull: {
    id: 'action.shopIdCannotBeNull',
    defaultMessage: '门店编码不能为空',
  },
  actionloginFailed: {
    id: 'action.loginFailed',
    defaultMessage: '登录失败',
  },
  actiongetVerifyCodeFailed: {
    id: 'action.getVerifyCodeFailed',
    defaultMessage: '验证码获取失败',
  },
  actionSending: {
    id: 'action.Sending',
    defaultMessage: '发送中...',
  },
  actionbalanceChanged: {
    id: 'action.balanceChanged',
    defaultMessage: '储值金额有变，请刷新页面重试',
  },
  actionsaving: {
    id: 'action.saving',
    defaultMessage: '保存中',
  },
  actionsaveSuccess: {
    id: 'action.saveSuccess',
    defaultMessage: '保存成功',
  },
  actionlogoutSuccess: {
    id: 'action.logoutSuccess',
    defaultMessage: '注销成功，请重新登录',
  },
  actionlogoutFailed: {
    id: 'action.logoutFailed',
    defaultMessage: '注销失败',
  },
  actiongetServiceCardFailed: {
    id: 'action.getServiceCardFailed',
    defaultMessage: '获取服务卡失败',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/action/part2/index.js